module.exports = __webpack_public_path__ + "img/fastvaluedeal-faq.418ab4a3.png";